import {React, observer} from '@api'
import {useFieldRendererStore} from '@design-board/stores'
import {Card, CardContent, Popover} from '@material-ui/core'
import {PopoverProps} from '@material-ui/core/Popover'
import {CatalogItemsList} from '@modules'
import { DetailsViewFieldConfig, useCatalog} from '@stores'
import * as css from './CatalogItemsChooser.css'
import { IMappedCatalogItemData } from '@modules/catalog'

export interface MyProps extends PopoverProps {
  field: DetailsViewFieldConfig
  selectedValues?: Set<string>,
  onSelectCatalogItem: (data: IMappedCatalogItemData) => void,
  onDeleteCatalogItem: (id: string) => any
}

export const CatalogItemsChooser = observer<MyProps>(({ selectedValues, field, onSelectCatalogItem, onDeleteCatalogItem, ...props }) => {
  const store = useFieldRendererStore(),
    { detailsStore: { sidebar }, catalogField } = store,
    catalog = useCatalog()

  return (
    <Popover {...props}>
      <Card className={css.cardItemsList}>
        <CardContent classes={{ root: css.cardContent }}>
          <CatalogItemsList
            isPopover onSelect={onSelectCatalogItem}
            selectedValues={selectedValues}
            align={sidebar?.align}
            workspace={sidebar?.associatedWorkspace ?? catalog?.workspaceConfig}
            onDelete={onDeleteCatalogItem}
            library={catalog.libraryByIndex[catalogField?.esIndex]}
          />
        </CardContent>
      </Card>
    </Popover>
  )
})

CatalogItemsChooser.defaultProps = {
  anchorOrigin: {
    vertical: 'center',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'center',
    horizontal: 'right'
  }
}



// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/CatalogItemsChooser.tsx